<template>
  <div
    :class="[
      'row',
      gutter ? `q-col-gutter-${gutter}` : '',
      { reverse: reverse },
      { 'justify-start': justifyStart },
      { 'justify-center': justifyCenter },
      { 'justify-end': justifyEnd },
      { 'justify-around': justifyAround },
      { 'justify-between': justifyBetween },
      { 'items-center': itemsCenter },
      { 'items-end': itemsEnd },
    ]"
  >
    <slot />
  </div>
</template>

<script>
import Vue from 'vue';

/**
 * This component using quasar Grid Row.
 * https://quasar.dev/layout/grid/row
 *
 * [Props]
 * gutter: none, xs, sm, md, lg, xl
 * https://quasar.dev/layout/grid/gutter#Introduction
 *
 * reverse: Flex reverse
 * https://quasar.dev/layout/grid/row#Reordering
 *
 * Horizontal alignment
 * justify~: Flex justify-content
 * https://quasar.dev/layout/grid/row#Example--Horizontal-alignment
 */

export default Vue.extend({
  name: 'CRow',
  props: {
    gutter: { type: String },
    reverse: { type: Boolean },

    //Horizontal alignment
    justifyStart: { type: Boolean },
    justifyCenter: { type: Boolean },
    justifyEnd: { type: Boolean },
    justifyAround: { type: Boolean },
    justifyBetween: { type: Boolean },

    // Vertical alignment
    itemsCenter: { type: Boolean },
    itemsEnd: { type: Boolean },
  },
});
</script>
